import { ShopifyWebhookIcon } from "@gadgetinc/widgets/src/icons/ShopifyWebhookIcon";
import { ThirdPartyIcon } from "@gadgetinc/widgets/src/icons/ThirdPartyIcon";
import { WebsiteIcon } from "@gadgetinc/widgets/src/icons/WebsiteIcon";
import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import type { DocsInterfaceProps } from "../../../../src/chrome/DocsInterface";
import { DocsInterface } from "../../../../src/chrome/DocsInterface";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../src/components/SplashPage";
import { OpenAIIcon } from "@gadgetinc/widgets/src/icons/OpenAIIcon";

const TutorialsLandingPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Tutorials</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          Gadget tutorials are designed to demonstrate how quickly and effortlessly you can build expressive, dynamic apps.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            title="Shopify apps"
            icon={<ShopifyWebhookIcon $size={32} />}
            color={colors.white}
            body="Learn how to build full-stack Shopify apps, use Shopify extensions, and build integrations."
            href="/guides/tutorials/shopify"
            copy="See the tutorials →"
          />
          <SplashCard
            title="BigCommerce apps"
            icon={<ThirdPartyIcon type="bigcommerce" $size={32} />}
            color={colors.white}
            body="Learn how to build full-stack BigCommerce apps."
            href="/guides/tutorials/bigcommerce"
            copy="See the tutorials →"
          />
          <SplashCard
            title="ChatGPT apps"
            icon={<OpenAIIcon $size={32} />}
            color={colors.white}
            body="Learn how to modify an MCP server and build widgets to build full stack ChatGPT apps."
            href="/guides/tutorials/chatgpt/todo-list"
            copy="See the tutorials →"
          />
          <SplashCard
            title="Web apps"
            icon={<WebsiteIcon $size={32} />}
            color={colors.white}
            body="Learn how to build full-stack web apps that use Gadget's built-in authentication system."
            href="/guides/tutorials/web-ai"
            copy="See the tutorials →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default TutorialsLandingPage;
